import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react'
import { useState } from 'react';
import { GrEmptyCircle} from "react-icons/gr";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";
import { FaRegTimesCircle } from "react-icons/fa";
import { FaRegCircle } from "react-icons/fa";
import { IoTriangleOutline } from "react-icons/io5";
import ProgressBar from 'react-bootstrap/ProgressBar';
import {Link, useNavigate} from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import Footer from './Common_Components/Footer';

const KanjiQuizMain = () => {
  const [activePage, setActivePage] = useState("Learning");
    const now = 20;
    const navigate = useNavigate();
    return (
      <div className='JLPTQuiz_Container ' >
          <div className='col-md-12'>
          <div className='header_inner' >
    <div className='container'>
    <div className='row'>
        <div className='col-md-12'>
        <ArrowBackIosIcon onClick={() => navigate("/Learn")} className='icon_1' />
        <h2>Kanji Quiz </h2>
        <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
        </div>
        </div>
        </div>
        </div>
          </div>
  
       <div className="container JLPT_Quiz" style={{marginTop:"100px",marginBottom:"100px"}}>
        <div className="row">
          <div className="col-md-12">
          <div className="btn_JLPT" style={{textAlign:"left"}}>
          <button   className='mt-4 mb-4 ' style={{border:"1px", fontWeight:"600", fontSize:"25px", backgroundColor:"white"}}>N5</button>
          </div>
            <div className="JLPTQuiz_btn d-flex justify-content-around  p-2 ">
              <Link to={"/QDontTry"} >
               <div className="JLPTQuiz-1 ">
               <GrEmptyCircle size={40} color='white' />
               </div>
               </Link>
               <Link to={"/QDontTry"} >
               <div className="JLPTQuiz-2 ">
           
               <FaRegCircle size={40} color='white' />
               </div>
               </Link>
               <Link to={"/QDontTry"} >
               <div className="JLPTQuiz-3">
               <IoTriangleOutline size={40} color='white'/>
               </div>
               </Link>
               <div className="JLPTQuiz-4">
               <FaRegTimesCircle size={40} color='white' />
               </div>
               <div className="JLPTQuiz-5"> 
                <HiOutlineDotsCircleHorizontal size={40} color='white' />
                </div>
            </div>
          </div>
          <div className="col-md-12">
  
             <div className="JLPT_Quiz_Progres_bar mt-3 bg-light p-2">
             <p style={{textAlign:"left", fontWeight:"500", fontSize:"20px"}}>Overall Progress</p>
             <ProgressBar now={now} label={`${now}%`} visuallyHidden variant='danger' className='JLPTQuiz_Progress_bar' />
             <p style={{textAlign:"right", fontWeight:"500", fontSize:"20px"}}>Total Attempted: 12 </p>
             </div>
            
      
          </div> 
        </div>
        <div className="row JLPT_Learning_Type mt-5 ">
          <div className="col-md-12 mt-5">
               <div className="row justify-content-center ">
                <div className=" JLPT_Reading col-md-2 me-3 mb-4">
                <Link to={'/writing-pratice'} style={{ textDecoration: 'none', color: 'inherit' }} >
                  <img src={`${process.env.PUBLIC_URL}/assets/images/writingLadki.jpeg`} alt="Penguine" className='JLPT_learn_img me-2' /><span className='JLPT_span'>Writting</span>
                  </Link>
                </div>
                
                {/* <div className=" JLPT_Listening col-md-2">
                  <Link to={'/ListeningQuiz'} style={{ textDecoration: 'none', color: 'inherit' }}  >
                <img src={`${process.env.PUBLIC_URL}/assets/images/writingLadki.jpeg`} alt="Penguine" className='JLPT_learn_img  me-2' /><span className='JLPT_span'>Listening</span>
                </Link>
                </div> */}
               </div>
          </div>
       
          </div>
       </div>
       <Footer />
      </div>
    )
  }
  

export default KanjiQuizMain
